import { useState } from 'react'
import { getApi } from '../../../../api/api'
import { useLocation, useNavigate } from 'react-router-dom'
import { CommonModals, Status } from '../../../types/enums'
import {
  CargoItemInterface,
  SlotItemInterface,
  TransportItemInterface,
} from '../../../types/interfaces'
import { useDispatch, useSelector } from 'react-redux'
import { selectModalState, setCommonModalState } from '../../../../store/slices/commonModalSlice'
import { RootState } from '../../../../store/store'

export const useStatusMenu = (
  item: SlotItemInterface | TransportItemInterface | CargoItemInterface,
) => {
  const [api] = useState(getApi())
  const location = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const statusMenuActive = useSelector((state: RootState) =>
    selectModalState(state, CommonModals.STATUS_MENU),
  )
  const setStatusMenuState = (state: boolean) =>
    dispatch(setCommonModalState({ modal: CommonModals.STATUS_MENU, state }))

  const updateStatus = async (id: number, status: Status) => {
    try {
      await api.updateStatus({ route: location.pathname.split('/')[1], id, status })
    } catch (error) {}
  }

  const startEdit = () => {
    localStorage.setItem('afterActionRoute', `/${location.pathname.split('/')[1]}/item/${item.id}`)
    navigate(`../${location.pathname.split('/')[1]}/form/${item.id}`)
  }

  const toggleExpanded = () => {
    setStatusMenuState(!statusMenuActive)
  }

  return { updateStatus, startEdit, statusMenuActive, toggleExpanded }
}
